__turbopack_context__.v({
  "container": "EVo43G_container",
  "country": "EVo43G_country",
  "country__code": "EVo43G_country__code",
  "country__select": "EVo43G_country__select",
  "error": "EVo43G_error",
  "field": "EVo43G_field",
  "fullWidth": "EVo43G_fullWidth",
  "hasError": "EVo43G_hasError",
  "hasWarning": "EVo43G_hasWarning",
  "label": "EVo43G_label",
  "label__disabled": "EVo43G_label__disabled",
  "number": "EVo43G_number",
  "shimmer": "EVo43G_shimmer",
  "statusIcon": "EVo43G_statusIcon",
  "text-bar-sweep": "EVo43G_text-bar-sweep",
  "withError": "EVo43G_withError",
});
